import Colors from '@/constants/Colors';
import { pxToVw } from '@/modules/styled/cssUnits';
import styled from 'styled-components';

export const StyledActivityTryFeedback = styled.div`
  width: 100%;
  height: 100%;
  padding: ${pxToVw(20)};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: ${pxToVw(20)};
  background-color: ${Colors.darkGreen}33;

  .text-feedback {
    text-align: center;
  }
  .repetitions-feedback,
  .feedback-actions {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 10px;
  }
`;
